import { render } from "./time-section.component.vue?vue&type=template&id=28b69b13&ts=true"
import script from "./time-section.component.vue?vue&type=script&lang=ts"
export * from "./time-section.component.vue?vue&type=script&lang=ts"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__